import React, { useState, useRef, useEffect } from "react";
import { useController } from "react-hook-form";
import { FilterButton } from "./FilterButton";
import { BiSort } from "react-icons/bi";

const sortOptions = [
  { label: "Lowest Price", value: "asc" },
  { label: "Highest Price", value: "desc" },
];

const SortDropdown = ({ control, name, setValue }) => {
  const { field } = useController({ name, control });
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getSortLabel = () =>
    `Sort: ${field.value === "asc" ? "Lowest Price" : "Highest Price"}`;

  const handleSortOrderChange = (value) => {
    setValue(name, value);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <FilterButton
        toggleDropdown={toggleDropdown}
        label={getSortLabel()}
        icon={<BiSort />}
        className="bg-gray-50 border border-gray-300 rounded-md px-3 py-2 hover:bg-gray-100"
      />

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg z-10 py-2">
          {sortOptions.map((o, i) => (
            <div
              key={i}
              onClick={() => handleSortOrderChange(o.value)}
              className={`cursor-pointer px-4 py-2 text-sm ${
                field.value === o.value ? "bg-blue text-white rounded-md" : "hover:bg-gray-100"
              }`}
            >
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdown;